import { render, staticRenderFns } from "./MapNgoCard.vue?vue&type=template&id=e3c2ea3e&"
import script from "./MapNgoCard.vue?vue&type=script&lang=js&"
export * from "./MapNgoCard.vue?vue&type=script&lang=js&"
import style0 from "./MapNgoCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports